import styled from 'styled-components'
import { StyledParagraph } from '../../../theme/Global/index'

export const MaintenanceMessage = styled(StyledParagraph)`
  font-size: 18px;
  line-height: 175%;
`
